export default {
  SET_LIST_ORDER(state, payload) {
    console.log('payload', payload)
    state.listInvoice = payload
  },
}
